class NfseAutorizacao {

    constructor(model = null) {
        this.dataHora = null;
        this.chaveAcesso = '';
        this.urlVisualizacao = '';

        if (!model)
            return;

        this.dataHora = model.dataHora;
        this.chaveAcesso = model.chaveAcesso;
        this.urlVisualizacao = model.urlVisualizacao;
    }
}

export default class NFSe {

    constructor(model = null) {
        
        this.id = 0;
        this.empresaId = 0;
        this.numero = 0;
        this.numeroRps = 0;
        this.serieRps = 1;
        this.doadorId = 0;
        this.dataEmissao = new Date().yyyymmdd();
        this.discriminacao = '';
        this.valor = 0;
        this.valorRetido = 0;
        this.aliquotaIss = 5;
        this.valorIss = 0;
        this.valorPis = 0;
        this.valorCofins = 0;
        this.valorCsll = 0;
        this.valorInss = 0;
        this.valorIrpj = 0;
        this.valorOutros = 0;
        this.valorLiquido = 0;
        this.retido = false;
        this.codigoServico = '';
        this.codigoTributacaoMunicipio = '';
        this.codigoNbs = '';
        this.retornoConsulta = '';
        this.codigoVerificacao = '';
        this.protocolo = '';
        this.urlVisualizacao = '';
        this.nfseAutorizacao = new NfseAutorizacao();
        this.justificativaCancelamento = '';
        this.situacao = 1;
        this.recebivelId = 0;

        if (!model)
            return;

        const autorizacao = model.nfseAutorizacao ? model.nfseAutorizacao : model.autorizacao;

        this.id = model.id ? model.id : 0;
        this.empresaId = model.empresaId;
        this.numero = model.numero;
        this.numeroRps = model.numeroRps;
        this.serieRps = model.serieRps;
        this.doadorId = model.doadorId;
        this.doador = model.doador;
        this.dataEmissao = new Date(model.dataEmissao).yyyymmdd();
        this.discriminacao = model.discriminacao;
        this.valor = model.valor;
        this.valorRetido = model.valorRetido;
        this.aliquotaIss = model.aliquotaIss;
        this.valorIss = model.valorIss;
        this.valorPis = model.valorPis;
        this.valorCofins = model.valorCofins;
        this.valorCsll = model.valorCsll;
        this.valorInss = model.valorInss;
        this.valorIrpj = model.valorIrpj;
        this.valorOutros = model.valorOutros;
        this.valorLiquido = model.valorLiquido;
        this.retido = model.retido;
        this.codigoServico = model.codigoServico;
        this.codigoTributacaoMunicipio = model.codigoTributacaoMunicipio;
        this.codigoNbs = model.codigoNbs;
        this.retornoConsulta = model.retornoConsulta;
        this.codigoVerificacao = model.codigoVerificacao;
        this.protocolo = model.protocolo;
        this.urlVisualizacao = model.urlVisualizacao ? model.urlVisualizacao : (autorizacao ? autorizacao.urlVisualizacao : '');
        this.nfseAutorizacao = autorizacao ? new NfseAutorizacao(autorizacao) : new NfseAutorizacao();
        this.justificativaCancelamento = model.justificativaCancelamento;
        this.situacao = model.situacao;
        this.recebivelId = model.recebivelId;
    }
}
